import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form, Select, Button, Alert } from 'antd'
import { sendPermissionRequest } from '../../actions/PermissionAction'
import { sendNotification, permissionTranslation } from '../../utils';
import './myPermissions.css'

export class PermissionRequest extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showPermission: false,
      newPermission: [],
      options: []
    }
  }

  componentDidMount() {
    const { item, intl } = this.props
    this.setState({
      options: item.permissions.filter(r => r.enabled !== true).map((r, k) => <Select.Option key={k} value={r.action}>{permissionTranslation(r.action, intl)}</Select.Option >)
    })
  }

  componentDidUpdate(prevProps) {
    const { permissionRequest, intl } = this.props

    if (permissionRequest && permissionRequest !== prevProps.permissionRequest) {
      sendNotification('success', intl, intl.formatMessage({ id: 'request_sent' }))
      this.props.handleHidePermissionRequest()
    }
  }

  handleOnChangeUser = (e) => {
    this.setState({ newPermission: e })
  }

  handleOnClick = (
    item,
    creatorEmail,
    creatorId,
    creatorName,
    permissions,
    groupName,
    groupId,
    requestingUserId,
    requestingUserName,
    requestingUserEmail,
    clientId
  ) => {
    const { intl } = this.props

    if (permissions.length === 0) {
      sendNotification('error', intl, intl.formatMessage({ id: 'must_one_permission' }))
    } else {
      if (creatorEmail && creatorName) {
        this.props.sendPermissionRequest(
          creatorEmail,
          creatorId,
          creatorName,
          permissions,
          groupName,
          groupId,
          requestingUserId,
          requestingUserName,
          requestingUserEmail,
          clientId,
          intl
        )
      } else {
        this.props.sendPermissionRequest(
          item.userCreator.email,
          item.userCreator.id,
          item.userCreator.name,
          permissions,
          groupName,
          groupId,
          requestingUserId,
          requestingUserName,
          requestingUserEmail,
          clientId,
          intl
        )
      }
    }
  }

  render() {
    const { newPermission, options } = this.state
    const { item, client, newColor, intl, user, isFetching } = this.props

    return (
      <React.Fragment >
        <Form.Item >
          <span>{intl.formatMessage({ id: "send_select_permissions" })}:</span>
          <Select
            mode="multiple"
            placeholder={intl.formatMessage({ id: "new_permissions" })}
            value={newPermission}
            onChange={this.handleOnChangeUser}
            style={{ width: '100%' }}>
            {options}
          </Select>
        </Form.Item>
        <Alert
          style={{ marginBottom: '36px' }}
          message={intl.formatMessage({ id: "warning" })}
          description={intl.formatMessage({ id: "warning_group_members" })}
          type="warning"
          showIcon
        />
        <Button
          type="primary"
          style={{ backgroundColor: newColor, borderColor: newColor, marginRight: '10px' }}
          loading={isFetching}
          onClick={() => {
            this.handleOnClick(
              item,
              item.creatorEmail,
              item.creatorId,
              item.creatorName,
              newPermission,
              item.name,
              item._id,
              user._id,
              user.name,
              user.email,
              client._id)
          }}
        >{intl.formatMessage({ id: "send_request" })}</Button>
        <Button
          style={{ color: newColor, borderColor: newColor }}
          onClick={this.props.handleHidePermissionRequest}
        >{intl.formatMessage({ id: "cancel_button" })}</Button>
      </React.Fragment >
    )
  }
}

const mapStateToProps = (state) => ({
  client: state.client.data,
  newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
  permissionRequest: state.permission.permissionRequest,
  isFetching: state.permission.permissionIsFetching,
  user: state.authUser.user,
})

const mapDispatchToProps = {
  sendPermissionRequest
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(PermissionRequest)))